import React, { useState, useEffect } from 'react';
import { MentalHealth, NetworkStatus } from '../../utils/types';
import Button from '@mui/material/Button';
import { ButtonArrayContainer, ButtonContainer, buttonStyles, notSureStyles, StackedButtonContainer, NotSureButtonContainer, SectionHeader } from '../../theme';
import NotSureMentalHealthModal from '../Modals/NotSureMentalHealthModal';
import { EventAction, trackMixpanelEvent } from '../../mixpanelAnalytics';

type Props = {
    mentalHealths: MentalHealth|undefined;
    handleMentalHealthSelect: (mentalHealth: NetworkStatus) => void;
}

type Option = {
    label:string;
    value:NetworkStatus;
}

const MentalHealthContainer = ({ mentalHealths, handleMentalHealthSelect }:Props): JSX.Element => {
    const [ open, setOpen ] = useState(false);
    const [ options, setOptions ] = useState<Option[]>();

    useEffect(() => {
        if (mentalHealths) {
            const options = [ { label: 'Commercial', value: mentalHealths.commercial }, { label: 'Medicare Advantage', value: mentalHealths.medicareAdvantage }, { label: 'Medi-Cal', value: mentalHealths.mediCal } ].filter(o => o.value !== NetworkStatus.NotAvailable);
            setOptions(options);
            if (options.length === 1) {
                handleMentalHealthSelect(options[0].value);
            }
        }
    }, []);

    const handleNotSure = () => {
        setOpen(!open);
        trackMixpanelEvent(EventAction.NOT_SURE_SELECTED, { selected: 'Mental Health' });
    };

    if (!mentalHealths) {
        return (<div></div>);
    }
    return (
        <>
            <ButtonArrayContainer>
                <SectionHeader>How do you get your insurance?</SectionHeader>
                <ButtonContainer>
                    <StackedButtonContainer>
                        {
                            options?.map((o:Option, i:number) => (
                                <Button
                                    key={i}
                                    sx={buttonStyles}
                                    variant='contained'
                                    onClick={() => { handleMentalHealthSelect(o.value); }}
                                >
                                    {o.label}
                                </Button>
                            ))
                        }
                    </StackedButtonContainer>
                    <NotSureButtonContainer>
                        <Button onClick={handleNotSure} variant='text' sx={notSureStyles}>Not Sure?</Button>
                    </NotSureButtonContainer>
                </ButtonContainer>
            </ButtonArrayContainer>
            <NotSureMentalHealthModal handleMentalHealthSelect={handleMentalHealthSelect} mentalHealths={mentalHealths} open={open} handleClose={() => { setOpen(false); }}/>
        </>
    );
};

export default MentalHealthContainer;
